import React from 'react';
import AbstractModalView from '../AbstractModalView';
import styles from './styles.module.scss';

const ButtonShowModal = ({
                           label,
                           buttonClassName,
                           popupClassName,
                           children,
                           pathname = 'info',
                           ...rest
                         }) => (
  <>
    <AbstractModalView
      subPath={pathname}
      triggerContent={({openModal}) => (
        <button
          type='button'
          className={`${styles.button} ${buttonClassName}`}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal();
          }}
          {...rest}
        >
          {label}
        </button>
      )}
      modalContent={({closeModal}) => (
        <>
          <div className={`${styles.modalContentContainer} ${popupClassName}`}>
            {children({closeModal})}
          </div>
        </>
      )}
      modalClassName={styles.modal}
    />
  </>
);

export default ButtonShowModal;